import React from "react";
import stringifyBit from "./bitTextParser";
import { IGambitComponentProp, IBitComponentProp } from "./types";
import "./Gambit.css";

function Bit({ bit, editable, onClick }: IBitComponentProp) {
  const className = `bit nes-btn ${editable ? "" : "is-disabled"}`;
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={!editable}
    >
      {stringifyBit(bit)}
    </button>
  );
}

export default function Gambit(props: IGambitComponentProp) {
  const { gambit, editable, clickHandler = () => {} } = props;
  const onClickMaker = (label: string) => () => clickHandler(gambit, label);
  return (
    <div className="gambit">
      <Bit
        bit={gambit.target}
        editable={editable}
        onClick={onClickMaker("target")}
      />
      <Bit
        bit={gambit.condition}
        editable={editable}
        onClick={onClickMaker("condition")}
      />
      <Bit
        bit={gambit.action}
        editable={editable}
        onClick={onClickMaker("action")}
      />
    </div>
  );
}
